<div class="container-fluid rounded bg-white rounded shadow">

  <div class="container-fluid shadow-sm p-3">
    <!-- Header Row -->
    <div class="row align-items-center mb-3">
      <div class="col-md-6 d-flex align-items-center gap-3">
        <button class="btn btn-light btn-sm" (click)="exitDoc()">← Back</button>
        <div class="fs-5 fw-bold">PDF Signer</div>
      </div>

      <div class="col-md-6 d-flex justify-content-end align-items-center gap-3 flex-wrap">
        <div class="d-flex align-items-center gap-2">
          <label for="pageSelect" class="text-muted mb-0">Page:</label>
          <select id="pageSelect" class="form-select form-select-sm w-auto"></select>
          <span class="text-muted small">(single page)</span>
        </div>

        <div class="form-check d-flex align-items-center gap-2 mb-0">
          <input type="checkbox" class="form-check-input" id="sameForAll" />
          <label class="form-check-label text-muted" for="sameForAll">
            Same position for all pages
          </label>
        </div>
      </div>
    </div>

    <!-- Action Buttons Row -->
    <div class="row">
      <div class="col-12 text-end d-flex justify-content-end gap-2 flex-wrap">
        <button id="addSignatureBtn" class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1">
          Add Signature (double-click also)
        </button>
        <button id="getData" class="btn btn-outline-success btn-sm d-flex align-items-center gap-1">
          Save Position
        </button>
        <button class="btn btn-success btn-sm px-3 d-flex align-items-center gap-1" [disabled]="this.signatureData.length == 0" (click)="saveDoc()">
          Submit
        </button>
      </div>
    </div>
  </div>

  <div id="viewer" class="viewer">
    <div id="loading" style="color:#6b7280">Loading PDF…</div>
  </div>

  <div class="d-flex align-items-center gap-3 border-top p-3 bg-light rounded-bottom">
    <div class="text-muted small">
      Tip: Double-click page to add signature at clicked location. Drag boxes to reposition.
    </div>
    <div class="ms-auto">
      <!-- <span class="text-muted small">Output:</span> -->
    </div>
  </div>

  <!-- <pre id="output"></pre> -->
</div>